import { InjectionToken } from "@angular/core";
import { AngularEditorConfig } from "@kolkov/angular-editor";

export const ANGULAR_EDITOR_CONFIG = new InjectionToken<AngularEditorConfig>(
  "ANGULAR_EDITOR_CONFIG"
);
